import { INVENTORY_SEARCH_KEY } from 'constants/search'

// Use Object.values to get all parameter values from INVENTORY_SEARCH_KEY
// Exclude displayAvailableOnly as it will be handled separately
const ALLOWED_INVENTORY_PARAMS = Object.values(INVENTORY_SEARCH_KEY).filter(
  (key) => key !== INVENTORY_SEARCH_KEY.displayAvailableOnly,
)

export const filterInventoryParams = (
  query: Record<string, any>,
): Record<string, unknown> => {
  const filtered: Record<string, unknown> = {}

  for (const key of ALLOWED_INVENTORY_PARAMS) {
    const value = query[key]
    if (value !== undefined && value !== null && value !== '') {
      filtered[key] = value
    }
  }

  return filtered
}

// Extract availableOnly from query params separately
export const extractAvailableOnly = (query: Record<string, any>): boolean => {
  return query[INVENTORY_SEARCH_KEY.displayAvailableOnly] === 'true'
}
